import { useEffect, useState } from "react";

import { apiGet } from "../../Api/Client.js";

const POLL_MS = 60000;

/**
 * Whether the Suggested Tasks menu item should show for this person: they hold the page, or at
 * least one waiting suggestion is theirs to decide. Asked of the server (it decides), polled like
 * the other menu dots. Once it has shown, it stays for the session: the menu never moves because
 * the person just handled their last suggestion.
 */
export function useSuggestedTasksMenu(enabled) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    const ask = () => apiGet("/axon/proposals/menu/")
      .then((answer) => { if (!cancelled && answer?.show) setShow(true); })
      .catch(() => {});
    ask();
    const timer = setInterval(ask, POLL_MS);
    return () => { cancelled = true; clearInterval(timer); };
  }, [enabled]);
  return show;
}
